import React, { useEffect, useState } from 'react';
import axiosInstance from '../util/axiosConfig';
import useVendorField from '../hooks/useVendorField';
import StockFormModal from './StockFormModal';
import AddVendorModal from './AddVendorModal';
import ImplantForm, {
  emptyImplantForm,
  implantFormToPayload,
  validateImplantForm
} from './ImplantForm';

const AddImplantModal = ({ open, onClose, onSuccess }) => {
  const [form, setForm] = useState(emptyImplantForm);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const {
    vendors,
    vendorsLoading,
    addVendorOpen,
    setAddVendorOpen,
    onAddVendor,
    handleVendorCreated
  } = useVendorField(open, (vendorId) => {
    setForm((prev) => ({ ...prev, vendor_id: vendorId }));
  });

  useEffect(() => {
    if (!open) return;
    setForm(emptyImplantForm());
    setError('');
  }, [open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const message = validateImplantForm(form);
    if (message) {
      setError(message);
      return;
    }
    try {
      setSubmitting(true);
      await axiosInstance.post('/implants', implantFormToPayload(form));
      onSuccess?.();
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add implant');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <StockFormModal
        open={open}
        onClose={onClose}
        title="Add Implant"
        error={error}
        onErrorClose={() => setError('')}
      >
        <ImplantForm
          form={form}
          onChange={handleChange}
          onSubmit={handleSubmit}
          loading={submitting}
          vendors={vendors}
          vendorsLoading={vendorsLoading}
          onAddVendor={onAddVendor}
          fullWidthSubmit={false}
        />
      </StockFormModal>
      <AddVendorModal
        open={addVendorOpen}
        onClose={() => setAddVendorOpen(false)}
        onCreated={handleVendorCreated}
      />
    </>
  );
};

export default AddImplantModal;
